<template>
  <div class="">
    <div v-if="Array.isArray(stats) && stats.length > 0" class="relative isolate overflow-hidden py-4 border-b">
      <dl class="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-4">
        <div v-for="stat in statsToShow" :key="stat.name" class="-z-20 min-h-[110px] relative overflow-hidden rounded-xl bg-slate-50 px-4 pt-4 pb-2">
          <dt class="truncate text-sm font-medium text-gray-500">{{ stat.name }}</dt>
          <dd :class="['mt-1 font-semibold tracking-tight text-gray-900', stat?.valueClass || 'text-xl']">{{ stat.value }}</dd>
          <dd class="mt-2 text-sm text-gray-400 font-medium">{{ stat?.description || '' }}</dd>
          <dd v-if="stat?.extraDescription" class="mt-2 text-xs text-gray-400 font-medium">{{ stat?.extraDescription || '' }}</dd>
          <db-easy-pie
            v-if="stat.gauge"
            class="-z-10 absolute right-1 top-1 h-28 w-28 rounded-full text-lg font-semibold text-slate-500"
            :value="isNaN(stat.value) ? 0 : stat.value"
            :max="stat.max"
            :line-width="8"
            :animated="true"
            :percent-ranges="stat?.percentRanges || []"
            :show-percents="stat.percents || false"
          ></db-easy-pie>
          <mdicon v-else-if="stat.icon" :name="stat.icon" :size="stat.iconSize || 105" :class="['-z-10 absolute right-1 top-1 rounded-full', stat.iconClass || '']" />
        </div>
      </dl>
    </div>

    <CategoriesSettingsEditor class="mt-4 mx-1"></CategoriesSettingsEditor>

    <!--
    <StdPropSetViewer v-if="isConversationEscalated" class="overflow-hidden mt-6" title="Escalation (Handoff)" :src="conversation" :propSet="handoffProps"></StdPropSetViewer>
    <StdPropSetViewer class="overflow-hidden mt-6" title="Client" :src="conversation" :propSet="clientProps"></StdPropSetViewer>
    -->
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import StdPropSetViewer from '@/components/Viewers/StdPropSetViewer.vue';
  import { ConversationDetailsReport } from '@enegelai/core';
  import DbEasyPie from '@/components/Charts/DbEasyPie.vue';
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  import { pathOr } from 'ramda';
  import { formatSeconds } from '@/utils/formatSeconds';
  import { useMd } from '@/hooks/useMd';
  import CategoriesSettingsEditor from '@/components/Categories/editors/CategoriesSettingsEditor.vue';

  //dayjs.extend(utc);

  const props = defineProps({
    conversation: {
      type: Object,
      default() {
        return {};
      },
    },
  });

  const md = useMd();

  const conversationId = computed(() => props.conversation?.id || '');
  const conversationDatetime = computed(() => props.conversation?.datetime || '');
  const conversationMedia = computed(() => props.conversation?.channelAttributes?.media || 'chat');

  const stats = ref([]);

  const statsTemp = computed(() => [
    {
      name: 'Categories',
      value: 0, // props.conversation?.stats?.botMessages || 0,
      icon: 'finance',
      iconClass: 'text-gray-200/60',
      description: 'Number of Categories',
      //extraDescription: `Higher is better`,
      show: true,
    },
    {
      name: 'Subcategories',
      value: 0, // props.conversation?.stats?.botMessages || 0,
      icon: 'finance',
      iconClass: 'text-gray-200/60',
      description: 'Number of SubCategories',
      //extraDescription: `Higher is better`,
      show: true,
    },
    {
      name: 'Sub-Subcategories',
      value: 0, // props.conversation?.stats?.botMessages || 0,
      icon: 'finance',
      iconClass: 'text-gray-200/60',
      description: 'Number of Sub-SubCategories',
      //extraDescription: `Higher is better`,
      show: true,
    },
  ]);

  const statsToShow = computed(() => stats.value.filter((x) => x.show));
</script>
